import { useEffect, useState } from 'preact/hooks'
import styles from './profile.module.css'

/** Delay before the fill moves to its target, so the CSS transition runs (no rAF needed). */
const FILL_DELAY_MS = 60

/**
 * XP bar whose fill slides from `from` to `to` (0..1) with a CSS transition (≤ 1 s, T2.4).
 * Key it by the values so a new race starts a fresh animation.
 */
export function XpBar({ from, to, label }: { from?: number; to: number; label: string }) {
  const [fill, setFill] = useState(from ?? to)
  useEffect(() => {
    if (fill === to) return
    const t = setTimeout(() => setFill(to), FILL_DELAY_MS)
    return () => clearTimeout(t)
  }, [to])
  return (
    <span
      class={styles.xpBar}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(to * 100)}
    >
      <span class={styles.xpFill} style={{ width: `${Math.round(fill * 1000) / 10}%` }} />
    </span>
  )
}

/** `Lv 3` badge, XP bar and `120 / 250 XP` (the profile screen's header). */
export function LevelBadge({
  level,
  xpIntoLevel,
  xpForNext,
}: {
  level: number
  xpIntoLevel: number
  xpForNext: number
}) {
  const to = xpForNext > 0 ? Math.min(1, xpIntoLevel / xpForNext) : 1
  return (
    <div class={styles.levelRow}>
      <span class={styles.badge}>Lv {level}</span>
      <XpBar to={to} label="Experience" />
      <span class={styles.xpText}>
        {xpForNext > 0 ? `${xpIntoLevel} / ${xpForNext} XP` : 'Top level'}
      </span>
    </div>
  )
}
